<template>
    <div class="page-wrapper admin-stats-sheet admin-stats-sheet--cols-4">
        <div class="stats-row">
            <div class="mini-stat" v-for="s in stats" :key="s.label">
                <div class="mini-stat-icon" :style="{ background: s.bg, color: s.color }">
                    <component :is="s.icon" />
                </div>
                <div>
                    <p class="mini-stat-val">{{ s.value }}</p>
                    <p class="mini-stat-label">{{ s.label }}</p>
                </div>
            </div>
        </div>

        <div class="page-toolbar admin-list-toolbar admin-list-toolbar--single-action">
            <div class="page-toolbar-left coach-courses-toolbar-left">
                <div class="search-box">
                    <el-icon>
                        <Search />
                    </el-icon>
                    <input v-model="searchQuery" type="text" placeholder="搜索课程名称" />
                </div>
                <div class="filter-group">
                    <el-select v-model="filterStatus" placeholder="筛选状态" style="width: 140px" @change="loadCourses">
                        <el-option label="全部状态" value="" />
                        <el-option label="进行中" :value="1" />
                        <el-option label="已下架" :value="2" />
                    </el-select>
                </div>
            </div>
            <div class="page-toolbar-right">
                <button class="btn-primary" @click="openAdd"><el-icon>
                        <Plus />
                    </el-icon><span>新增课程</span></button>
            </div>
        </div>

        <div class="courses-grid">
            <div class="course-card" v-for="course in filteredCourses" :key="course.courseId">
                <div class="course-header">
                    <h3 class="course-name">{{ course.name }}</h3>
                    <span class="status-badge" :class="course.status === 1 ? 'active' : 'inactive'">
                        {{ course.status === 1 ? '进行中' : '已下架' }}
                    </span>
                </div>
                <p class="course-desc">{{ course.description }}</p>
                <div class="course-meta">
                    <div class="meta-item">
                        <span class="meta-label">分类</span>
                        <span class="meta-value">{{ course.category }}</span>
                    </div>
                    <div class="meta-item">
                        <span class="meta-label">难度</span>
                        <span class="meta-value">{{ course.difficulty }}</span>
                    </div>
                    <div class="meta-item">
                        <span class="meta-label">时长</span>
                        <span class="meta-value">{{ course.duration }}分钟</span>
                    </div>
                    <div class="meta-item">
                        <span class="meta-label">容量</span>
                        <span class="meta-value">{{ course.capacity }}人</span>
                    </div>
                </div>
                <div class="course-stats">
                    <div class="stat">
                        <p class="stat-val">¥{{ course.price }}</p>
                        <p class="stat-label">价格</p>
                    </div>
                    <div class="stat">
                        <p class="stat-val">{{ course.appointmentCount || 0 }}</p>
                        <p class="stat-label">预约数</p>
                    </div>
                </div>
                <div class="course-schedule">
                    <span class="schedule-label">课程时间：</span>
                    <span class="schedule-value">{{ course.courseSchedule }}</span>
                </div>
                <div class="course-actions">
                    <button class="act-btn edit" @click="editCourse(course)" title="编辑"><el-icon>
                            <Edit />
                        </el-icon></button>
                    <button class="act-btn del" @click="deleteCourse(course)" title="删除"><el-icon>
                            <Delete />
                        </el-icon></button>
                </div>
            </div>
            <div v-if="filteredCourses.length === 0" class="empty-state">
                <p>暂无课程数据</p>
            </div>
        </div>

        <el-dialog v-model="showDialog" :title="editing ? '编辑课程' : '新增课程'" width="600px">
            <el-form :model="form" label-width="100px">
                <el-form-item label="课程名称" required>
                    <el-input v-model="form.name" placeholder="请输入课程名称" />
                </el-form-item>
                <el-form-item label="课程描述" required>
                    <el-input v-model="form.description" type="textarea" :rows="3" placeholder="请输入课程描述" />
                </el-form-item>
                <el-form-item label="分类" required>
                    <el-input v-model="form.category" placeholder="如：力量训练、瑜伽、有氧运动" />
                </el-form-item>
                <el-form-item label="难度" required>
                    <el-select v-model="form.difficulty" style="width: 100%">
                        <el-option label="初级" value="初级" />
                        <el-option label="中级" value="中级" />
                        <el-option label="高级" value="高级" />
                    </el-select>
                </el-form-item>
                <el-form-item label="时长（分钟）" required>
                    <el-input-number v-model="form.duration" :min="15" :max="180" />
                </el-form-item>
                <el-form-item label="容量（人）" required>
                    <el-input-number v-model="form.capacity" :min="1" :max="100" />
                </el-form-item>
                <el-form-item label="价格（元）" required>
                    <el-input-number v-model="form.price" :min="0" :precision="2" />
                </el-form-item>
                <el-form-item label="课程时间" required>
                    <el-input v-model="form.courseSchedule" placeholder="如：周一,周三,周五 19:00-20:00" />
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="form.status" style="width: 100%">
                        <el-option label="进行中" :value="1" />
                        <el-option label="已下架" :value="2" />
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <button class="btn-secondary" @click="showDialog = false">取消</button>
                    <button class="btn-primary" @click="saveCourse">保存</button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { Search, Plus, Edit, Delete, Notebook, TrendCharts, UserFilled, Star } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '@/api/request'

export default {
    name: 'CoachCoursesView',
    components: { Search, Plus, Edit, Delete, Notebook, TrendCharts, UserFilled, Star },
    data() {
        return {
            searchQuery: '',
            filterStatus: '',
            showDialog: false,
            editing: null,
            form: {
                name: '',
                description: '',
                category: '',
                difficulty: '初级',
                duration: 60,
                capacity: 15,
                price: 99.00,
                courseSchedule: '',
                status: 1,
            },
            courses: [],
            stats: [
                { label: '总课程数', value: '-', icon: 'Notebook', bg: 'rgba(0,98,255,0.1)', color: '#0062FF' },
                { label: '进行中', value: '-', icon: 'TrendCharts', bg: 'rgba(16,185,129,0.1)', color: '#10B981' },
                { label: '总预约数', value: '-', icon: 'UserFilled', bg: 'rgba(139,92,246,0.1)', color: '#8B5CF6' },
                { label: '平均评分', value: '-', icon: 'Star', bg: 'rgba(245,158,11,0.1)', color: '#F59E0B' },
            ],
        }
    },
    computed: {
        filteredCourses() {
            let result = this.courses
            if (this.searchQuery) {
                result = result.filter(c => c.name.includes(this.searchQuery))
            }
            if (this.filterStatus !== '') {
                result = result.filter(c => c.status === this.filterStatus)
            }
            return result
        },
    },
    mounted() {
        this.loadCourses()
    },
    methods: {
        async loadCourses() {
            try {
                const res = await api.getCoachCourses()
                if (res.data && res.data.code === 200) {
                    this.courses = res.data.data || []
                    const active = this.courses.filter(c => c.status === 1).length
                    const totalAppointments = this.courses.reduce((s, c) => s + (c.appointmentCount || 0), 0)
                    const avgRating = this.courses.length ? (this.courses.reduce((s, c) => s + (c.rating || 0), 0) / this.courses.length).toFixed(1) : '-'

                    this.stats[0].value = String(this.courses.length)
                    this.stats[1].value = String(active)
                    this.stats[2].value = String(totalAppointments)
                    this.stats[3].value = avgRating
                }
            } catch (e) {
                this.$message.error('加载课程数据失败')
            }
        },
        openAdd() {
            this.editing = null
            this.form = {
                name: '',
                description: '',
                category: '',
                difficulty: '初级',
                duration: 60,
                capacity: 15,
                price: 99.00,
                courseSchedule: '',
                status: 1,
            }
            this.showDialog = true
        },
        editCourse(course) {
            this.editing = course
            this.form = {
                courseId: course.courseId,
                name: course.name,
                description: course.description,
                category: course.category,
                difficulty: course.difficulty,
                duration: course.duration,
                capacity: course.capacity,
                price: course.price,
                courseSchedule: course.courseSchedule,
                status: course.status,
            }
            this.showDialog = true
        },
        async deleteCourse(course) {
            try {
                await ElMessageBox.confirm(`确定删除课程 "${course.name}" 吗？`, '提示', { type: 'warning' })
                const res = await api.removeCoachCourse(course.courseId)
                if (res.data && res.data.code === 200) {
                    ElMessage.success('删除成功')
                    this.loadCourses()
                } else {
                    ElMessage.error(res.data?.message || '删除失败')
                }
            } catch (e) {
                if (e !== 'cancel') ElMessage.error('操作失败')
            }
        },
        async saveCourse() {
            if (!this.form.name || !this.form.description || !this.form.category || !this.form.courseSchedule) {
                ElMessage.error('请填写必填项')
                return
            }
            try {
                const form = { ...this.form }
                let res
                if (this.editing) {
                    res = await api.updateCoachCourse(form)
                } else {
                    res = await api.saveCoachCourse(form)
                }
                if (res.data && res.data.code === 200) {
                    ElMessage.success('保存成功')
                    this.showDialog = false
                    this.loadCourses()
                } else {
                    ElMessage.error(res.data?.message || '保存失败')
                }
            } catch (e) {
                ElMessage.error('保存失败')
            }
        },
    },
}
</script>

<style scoped>
.page-wrapper {
    padding: 0;
    background: var(--bg-base);
    min-height: 100vh;
}

.page-title {
    font-size: 22px;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0 0 4px;
}

.breadcrumb {
    font-size: 13px;
    color: var(--text-muted);
    display: flex;
    gap: 6px;
}

.breadcrumb .sep {
    color: var(--border-color);
}

.breadcrumb .cur {
    color: var(--primary-blue);
    font-weight: 500;
}

.btn-primary {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0 18px;
    height: 38px;
    background: var(--gradient-primary);
    color: white;
    border: none;
    border-radius: var(--radius-md);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
}

.btn-primary:hover {
    transform: translateY(-1px);
    box-shadow: var(--shadow-glow);
}

.btn-secondary {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0 18px;
    height: 38px;
    background: var(--bg-gray);
    color: var(--text-primary);
    border: 1px solid var(--border-color);
    border-radius: var(--radius-md);
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s;
}

.btn-secondary:hover {
    border-color: var(--primary-blue);
    color: var(--primary-blue);
}

.coach-courses-toolbar-left {
    flex: 1;
}

.mini-stat {
    background: var(--bg-white);
    border: 1px solid var(--border-color);
    border-radius: var(--radius-lg);
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 14px;
    transition: all 0.3s;
}

.mini-stat:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-lg);
}

.mini-stat-icon {
    width: 44px;
    height: 44px;
    border-radius: var(--radius-md);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
}

.mini-stat-val {
    font-size: 22px;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0 0 2px;
    font-family: 'Inter', sans-serif;
}

.mini-stat-label {
    font-size: 12px;
    color: var(--text-muted);
    margin: 0;
}

.search-box {
    display: flex;
    align-items: center;
    background: var(--bg-white);
    border: 1px solid var(--border-color);
    border-radius: var(--radius-md);
    padding: 0 12px;
    height: 38px;
    flex: 1;
    max-width: 300px;
    gap: 8px;
    transition: all 0.3s;
}

.search-box:focus-within {
    border-color: var(--primary-blue);
    box-shadow: 0 0 0 3px rgba(0, 98, 255, 0.08);
}

.search-box .el-icon {
    color: var(--text-muted);
}

.search-box input {
    border: none;
    background: transparent;
    color: var(--text-primary);
    font-size: 14px;
    outline: none;
    flex: 1;
}

.search-box input::placeholder {
    color: var(--text-muted);
}

.filter-group {
    display: flex;
    gap: 12px;
}

.courses-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;
}

.course-card {
    background: var(--bg-white);
    border: 1px solid var(--border-color);
    border-radius: var(--radius-lg);
    padding: 20px;
    transition: all 0.3s;
    display: flex;
    flex-direction: column;
}

.course-card:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-lg);
}

.course-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
}

.course-name {
    font-size: 16px;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0;
    flex: 1;
}

.status-badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
}

.status-badge.active {
    background: rgba(16, 185, 129, 0.1);
    color: #10B981;
}

.status-badge.inactive {
    background: rgba(245, 158, 11, 0.1);
    color: #F59E0B;
}

.course-desc {
    font-size: 13px;
    color: var(--text-secondary);
    margin: 0 0 12px;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.course-meta {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin-bottom: 12px;
    padding: 12px;
    background: var(--bg-gray);
    border-radius: var(--radius-md);
}

.meta-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.meta-label {
    font-size: 11px;
    color: var(--text-muted);
    font-weight: 600;
}

.meta-value {
    font-size: 13px;
    color: var(--text-primary);
    font-weight: 600;
}

.course-stats {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
}

.stat {
    flex: 1;
    text-align: center;
    padding: 10px;
    background: rgba(0, 98, 255, 0.05);
    border-radius: var(--radius-md);
}

.stat-val {
    font-size: 18px;
    font-weight: 700;
    color: var(--primary-blue);
    margin: 0 0 2px;
}

.stat-label {
    font-size: 11px;
    color: var(--text-muted);
    margin: 0;
}

.course-schedule {
    font-size: 12px;
    color: var(--text-secondary);
    margin-bottom: 12px;
    padding: 8px;
    background: var(--bg-gray);
    border-radius: var(--radius-sm);
}

.schedule-label {
    font-weight: 600;
}

.schedule-value {
    color: var(--text-primary);
}

.course-actions {
    display: flex;
    gap: 8px;
    margin-top: auto;
}

.act-btn {
    flex: 1;
    height: 32px;
    border: none;
    border-radius: var(--radius-sm);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 14px;
    font-weight: 600;
}

.act-btn.edit {
    background: rgba(245, 158, 11, 0.1);
    color: #F59E0B;
}

.act-btn.edit:hover {
    background: #F59E0B;
    color: white;
}

.act-btn.del {
    background: rgba(239, 68, 68, 0.1);
    color: #EF4444;
}

.act-btn.del:hover {
    background: #EF4444;
    color: white;
}

.empty-state {
    grid-column: 1 / -1;
    text-align: center;
    padding: 60px 20px;
    color: var(--text-muted);
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

@media (max-width: 480px) {
    .courses-grid { grid-template-columns: 1fr; gap: 14px; }
}
</style>
